var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 500 500)",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M847.923 796.774c-73.83 73.882-129.28 62.822-129.28 62.822l-554.291-554.291-51.712-243.866 243.866 51.712 554.24 554.24c0 0 11.11 55.45-62.822 129.382zM341.965 142.49l-83.098-17.92c-8.038 15.002-17.715 30.003-35.379 47.718-17.664 17.664-32.717 27.29-47.718 35.328l17.971 83.149 24.013 24.013c0 0 45.261-0.922 96.307-51.968 51.098-51.098 52.019-96.358 52.019-96.358l-24.115-23.962z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.aba2fa9b17be2a91f9c062a8dcbca7ca.svg";
export { ForwardRef as ReactComponent };